var Application = function ($) {
  "use strict";

  return {
    isSmooth: function (params) {
      const isTouchDevice = "ontouchstart" in document.documentElement;

      disableScroll();
      if (!isTouchDevice) smoothScroll();

      window.onresize = () => {
        resizeBodyHeight();
      };

      window.onload = () => {
        enableScroll();
        resizeBodyHeight();
      };

      // Functions

      function disableScroll() {
        document.body.style.overflow = "hidden";
      }

      function enableScroll() {
        document.body.style.overflow = "";
      }

      function smoothScroll() {
        document.querySelector(".viewport").classList.add("SmoothScroll");

        new SmoothScroll({
          target: document.querySelector(".container"),
          scrollEase: 0.08,
          maxOffset: 500,
        });
      }

      function resizeBodyHeight() {
        document.body.style.height =
          document.querySelector(".viewport").scrollHeight + "px";
      }
    },

    isAnimation: function () {
      $(window).on("scroll resize load", function () {
        var offset = window.pageYOffset + window.innerHeight / 1.2;
        if ($(".pr-who").offset().top < offset) {
          $(".pr-who").addClass("pr-ani__to-top");
          $(".pr-who__info").addClass("pr-ani__to-top");
          $(".pr-who__images").addClass("pr-ani__to-top");
        }
      });
    },
  };
};

var App = Application(jQuery);
$(document).ready(function () {
  // инициализвция логотипа
  try {
    init();
  } catch (e) {}
  App.isAnimation();
  App.isSmooth();
});

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map

//# sourceMappingURL=app.js.map
